import { render } from "./NotificationsView.vue?vue&type=template&id=bdc8b544&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"

import "./NotificationsView.vue?vue&type=style&index=0&id=bdc8b544&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc8b544"]])

export default __exports__